export const attacksPaths = {
  absolute: '/:clientId/attacks',

  attackDetails: {
    absolute: '/:clientId/attacks/:attackId',
    relative: ':attackId',
  },
} as const;
